import React, { ChangeEvent, InputHTMLAttributes } from "react";

import { IConsolePageInputsProps } from "@Console/types";

import { InputColorContainer } from "./styles";

type IUnionInputProps = IConsolePageInputsProps &
  InputHTMLAttributes<HTMLInputElement>;

interface IInputColorProps extends IUnionInputProps {
  useCustomId?: boolean;
  setValue: React.Dispatch<React.SetStateAction<string>>;
}

export const InputColor = ({
  label,
  required,
  isInvalid,
  useCustomId,
  value,
  setValue,
  ...props
}: IInputColorProps) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (props?.onChange) props.onChange(event);
  };

  const colorHex = document.getElementById("color-hex") as HTMLInputElement;
  const colorPicker = document.getElementById(
    "color-picker",
  ) as HTMLInputElement;

  colorHex?.addEventListener("input", function () {
    const color = this.value;
    if (/^#[0-9A-F]{6}$/i.test(color)) {
      colorPicker.value = color;
    }
  });

  window?.addEventListener("load", function () {
    const initialColor = "#000000";
    colorHex.value = initialColor;
    colorPicker.value = initialColor;
  });

  return (
    <InputColorContainer isInvalid={isInvalid}>
      <label>
        {label}
        {required && <span className="required-flag">*</span>}
      </label>

      <input
        type="color"
        id="color-picker"
        value={value}
        onChange={(e) => setValue(e?.target?.value)}
        defaultValue={value ? value : "#ff0000"}
      />
      <input
        className="input"
        onChange={handleChange}
        value={value}
        required={required}
        {...props}
        autoComplete="off"
        data-testid="console-page-input"
        id="color-hex"
        placeholder="#000000"
      />
    </InputColorContainer>
  );
};
